import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import CategoryFilter from './components/CategoryFilter';
import ProductCard from './components/ProductCard';
import Pagination from './components/Pagination';
const ProductGridApp = ({ initialCategory, perPage, filterPortalId, }) => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeCategory, setActiveCategory] = useState(initialCategory);
    const [currentPage, setCurrentPage] = useState(1);
    const portalEl = filterPortalId ? document.getElementById(filterPortalId) : null;
    useEffect(() => {
        const load = async () => {
            try {
                const config = window.enoSearchConfig;
                const response = await fetch(config.apiUrl, {
                    headers: { 'X-WP-Nonce': config.nonce },
                });
                if (!response.ok)
                    throw new Error(`HTTP ${response.status}`);
                const data = await response.json();
                setProducts(data.products || []);
            }
            catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to load products');
            }
            finally {
                setLoading(false);
            }
        };
        load();
    }, []);
    const filteredProducts = activeCategory
        ? products.filter(p => p.categories.some(c => c.slug === activeCategory))
        : products;
    const totalPages = Math.ceil(filteredProducts.length / perPage);
    const start = (currentPage - 1) * perPage;
    const pageProducts = filteredProducts.slice(start, start + perPage);
    const handleCategoryChange = (slug) => {
        setActiveCategory(slug);
        setCurrentPage(1);
    };
    if (loading) {
        return _jsx("div", { className: "eno-grid-status eno-grid-loading", children: "Loading products\u2026" });
    }
    if (error) {
        return _jsx("div", { className: "eno-grid-status eno-grid-error", children: error });
    }
    if (products.length === 0) {
        return _jsx("div", { className: "eno-grid-status", children: "No products found." });
    }
    const filter = (_jsx(CategoryFilter, { products: products, activeCategory: activeCategory, onCategoryChange: handleCategoryChange, variant: portalEl ? 'sidebar' : 'horizontal' }));
    return (_jsxs("div", { className: "eno-product-grid-app", children: [portalEl ? createPortal(filter, portalEl) : filter, _jsx("div", { className: "eno-product-grid", children: pageProducts.map(product => (_jsx(ProductCard, { product: product }, product.id))) }), _jsx(Pagination, { currentPage: currentPage, totalPages: totalPages, onPageChange: page => {
                    setCurrentPage(page);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                } })] }));
};
export default ProductGridApp;
